var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAscSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2263 1.80933C10.4795 1.80933 10.6887 1.99743 10.7218 2.24148L10.7263 2.30933V11.3878C10.7263 11.664 10.5025 11.8878 10.2263 11.8878C9.97322 11.8878 9.76402 11.6997 9.73091 11.4557L9.72635 11.3878V2.30933C9.72635 2.03318 9.95021 1.80933 10.2263 1.80933Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5904 8.30449C12.7852 8.10878 13.1018 8.10805 13.2975 8.30286C13.4754 8.47996 13.4922 8.7577 13.3474 8.95377L13.2992 9.00996L10.5806 11.7411C10.403 11.9196 10.1241 11.9358 9.92806 11.7898L9.8719 11.7411L7.15338 9.00996C6.95857 8.81425 6.9593 8.49767 7.15502 8.30286C7.33294 8.12576 7.61075 8.11026 7.80615 8.25595L7.86212 8.30449L10.226 10.6792L12.5904 8.30449Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60742 0.000488281C3.86055 0.000488281 4.06975 0.188591 4.10286 0.432641L4.10742 0.500488V9.57901C4.10742 9.85515 3.88356 10.079 3.60742 10.079C3.35429 10.079 3.14509 9.8909 3.11199 9.64685L3.10742 9.57901V0.500488C3.10742 0.224346 3.33128 0.000488281 3.60742 0.000488281Z",
    fill: "#7083A3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25313 0.147265C3.43081 -0.0312379 3.70964 -0.0474654 3.90571 0.098582L3.96187 0.147265L6.68038 2.87838C6.87519 3.07409 6.87446 3.39067 6.67875 3.58548C6.50083 3.76258 6.22302 3.77808 6.02761 3.63239L5.97164 3.58385L3.60735 1.20844L1.24335 3.58385C1.06625 3.76177 0.788508 3.77855 0.592432 3.63376L0.536242 3.58548C0.358321 3.40838 0.341542 3.13064 0.486325 2.93457L0.534608 2.87838L3.25313 0.147265Z",
    fill: "#7083A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscSort);
export default __webpack_public_path__ + "static/media/asc-sort.a5f4e831a32521651e0e2972492b6cd5.svg";
export { ForwardRef as ReactComponent };